export enum ShipmentRequestStatus {
  Started = 'STARTED',
  InTransit = 'IN_TRANSIT',
  Returned = 'RETURNED',
  Delivered = 'DELIVERED',
  ArrivePickupLocation = 'ARRIVED_AT_PICKUP_LOCATION',
  Loaded = 'LOADED',
  ArriveDropOffLocation = 'ARRIVED_AT_DROP_OFF_LOCATION'
}
